
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SpsaProdViewDto } from './spsa-prod-view.dto';

export class SpsaProdViewResponseModel extends GlobalResponseObject {
    data?: SpsaProdViewDto[];


    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     * @param data1 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: any,data1?: SpsaProdViewDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;

    }
}